import React from 'react';

import { HStack, Pressable, Text } from '@rbilabs/universal-components';
import { useIntl } from 'react-intl';

import { Halal } from 'components/ucl/svgs/Halal';

import {
  Address,
  ServiceModes,
  Status,
  StoreCardViewContainer,
  disableColorProp,
} from '../store-card.styled';
import { StoreCardDetailsProps } from '../types';

import { StoreCardError } from './store-card-error';

export const StoreCardDetails: React.FC<StoreCardDetailsProps> = ({
  errorMessage,
  isSelected,
  storeDetails,
  onInfoPress,
  isInMapView,
}) => {
  const { formatMessage } = useIntl();
  const {
    restaurantStatus,
    serviceModesText,
    address,
    city,
    isHalal,
    distanceText,
    isActive,
  } = storeDetails;
  const storeInfo = `${distanceText} ${restaurantStatus.text}`;
  const storeCaptionAccessibility = isHalal ? formatMessage({ id: 'isHalalTitle' }) : storeInfo;
  const accessibilityLabel = `${address}, ${storeCaptionAccessibility}, ${serviceModesText}`;
  const showRestaurantStatus =
    (isSelected && restaurantStatus.isOpen) || !restaurantStatus.isOpen || isInMapView;

  return (
    <StoreCardViewContainer
      accessibilityState={{ expanded: !!isSelected }}
      accessibilityRole="togglebutton"
      accessibilityLabel={accessibilityLabel}
      accessible
      dd-action-name={`${storeDetails.address} open accordion`}
    >
      {address && (
        <HStack>
          <Pressable onPress={onInfoPress}>
            <Address {...(!isActive && disableColorProp)}>{address}</Address>
            <Text variant="copyTwo" {...(!isActive && disableColorProp)}>
              {city}
            </Text>
          </Pressable>
        </HStack>
      )}
      {isHalal && <Halal title={formatMessage({ id: 'isHalalTitle' })} />}
      {serviceModesText && (
        <HStack alignItems="center">
          <ServiceModes {...(!isActive && disableColorProp)}>{serviceModesText}</ServiceModes>
        </HStack>
      )}
      {showRestaurantStatus && (
        <Status
          isWithinOneHourOfClose={restaurantStatus.isWithinOneHourOfClose}
          isOpen={restaurantStatus.isOpen && isActive}
        >
          {restaurantStatus.text}
        </Status>
      )}
      {errorMessage && <StoreCardError message={errorMessage} />}
    </StoreCardViewContainer>
  );
};
